/* 绑定银行卡(已绑定) */
<template>
    <div class="bound-card-box">
        <!-- 头部 -->
        <headerTop title="绑定银行卡">

        </headerTop>
        <!-- 内容 -->
        <div class="content">
            <!-- 提示 -->
            <div class="tips">
                <span>您已绑定银行卡，可进行</span>
                <span>账户余额提现</span>
            </div>
            <!-- 银行 -->
            <div class="content-item bank">
                <span>银行</span>
                <span>{{ accountDetail.bank_name }}</span>
            </div>
            <!-- 卡号 -->
            <div class="content-item code">
                <span>卡号</span>
                <span>{{ accountDetail.bank_card_id }}</span>
            </div>
            <!-- 姓名 -->
            <div class="content-item user-name">
                <span>姓名</span>
                <span>{{ accountDetail.bank_card_owner }}</span>
            </div>
            <!-- 身份证 -->
            <div class="content-item identity-code">
                <span>身份证</span>
                <span>{{ accountDetail.owner_id_card }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import headerTop from "@/components/common/headerTop.vue";
import accountApi from "@/api/accountApi";

export default {
    data() {
        return {
            accountDetail: {}
        };
    },
    components: {
        headerTop
    },
    async mounted() {
        let res = await accountApi.accountBank();
        if (res.id !== undefined) {
            this.$store.commit('setAccountBankObj', res);
            this.accountDetail = res;
        } else {
            this.$router.push({
                name: "bindingCard"
            });
        }
    }
};
</script>

<style lang="less" scoped>
.bound-card-box {

    .content {
        padding: 28px 15px;
        .tips {
            & span:nth-child(1) {
                font-size: 14px;
                color: #999999;
            }
            & span:nth-child(2) {
                font-size: 14px;
                color: #ea2c2c;
            }
        }
        .content-item {
            height: 50px;
            width: 100%;
            border-bottom: 1px solid #e4e4e4;
            display: flex;
            align-items: center;
            font-size: 14px;
            & span:nth-child(2) {
                margin-left: 32px;
                color: #999999;
            }
        }
        .identity-code {
            & span:nth-child(2) {
                margin-left: 19px !important;
                color: #999999;
            }
        }
    }
}
</style>
